import { IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FC } from 'react'

export const ReportCharm: FC<{ icon: IconDefinition; label: string }> = ({
  icon,
  label,
}) => {
  return (
    <span className="flex flex-row items-center text-xs font-medium text-neutral-600 gap-2">
      <FontAwesomeIcon icon={icon} />
      {label}
    </span>
  )
}
